'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HighlightText = function HighlightText(props) {
  var search = props.search,
      children = props.children;

  if (!children) {
    return null;
  }

  var start = children.search(new RegExp(search, 'i'));
  var end = start + search.length;

  if (start < 0) {
    return _react2.default.createElement('span', null, children);
  }

  return _react2.default.createElement('span', null, children.substring(0, start), _react2.default.createElement('strong', null, children.substring(start, end)), children.substring(end, children.length));
};

HighlightText.propTypes = {
  search: _propTypes2.default.string,
  children: _propTypes2.default.string
};
exports.default = HighlightText;